<!--
 * @Author: Junjie
 * @Date: 2022-09-23 17:42:10
 * @LastEditTime: 2022-09-24 15:20:15
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/maintenance/duty/modules/AccountDetectModal.vue
-->
<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
  >
    <a-form-model :model="model" :rules="validatorRules" ref="form">
      <a-form-model-item prop="username" required>
        <a-input placeholder="请输入帐户名" size="large" v-model="model.username">
          <a-icon :style="{ color: 'rgba(0,0,0,.25)' }" slot="prefix" type="user" />
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="password" required>
        <a-input :type="password" autocomplete="false" placeholder="请输入密码" size="large" v-model="model.password">
          <a-icon :style="{ color: 'rgba(0,0,0,.25)' }" slot="prefix" type="lock" />
          <a-icon
            :style="{fontSize:'20px', color: 'rgba(0,0,0,.25)' }"
            :type="password==='text'?'eye':'eye-invisible'"
            @click="changeType(password==='text')"
            slot="suffix"
            theme="twoTone"
          />
        </a-input>
      </a-form-model-item>
    </a-form-model>
  </j-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'

  export default {
    name: 'AccountDetectModal',
    components: {
    },
    data () {
      return {
        title: '账号校验',
        width: 500,
        visible: false,
        disableSubmit: false,
        manager: '',
        model: {},
        validatorRules: {
          username: [
            { required: true, message: '请输入用户名!' },
            { validator: this.handleUsernameOrEmail }
          ],
          password: [{
            required: true, message: '请输入密码!', validator: 'click'
          }],
        },
        delubukejian: true, //眼睛显示隐藏
        password: 'password', //input 密码隐藏
        url: {
          'accountDetect': '/sys/account/detect'
        },
      }
    },
    methods: {
      requestFailed (err) {
        let description = ((err.response || {}).data || {}).message || err.message || '请求出现错误，请稍后再试'
        this.$notification['error']({
          message: '校验失败',
          description: description,
          duration: 4
        });
      },
      requestSuccess (loginResult) {
        console.log(loginResult);
      },
      // 判断登录类型
      changeType (v) {
        this.password = v ? 'password' : 'text'
      },
      /**
       * 验证字段
       * @param arr
       * @param callback
       */
      validateFields (arr, callback) {
        let promiseArray = []
        for (let item of arr) {
          let p = new Promise((resolve, reject) => {
            this.$refs['form'].validateField(item, (err) => {
              if (!err) {
                resolve();
              } else {
                reject(err);
              }
            })
          });
          promiseArray.push(p)
        }
        Promise.all(promiseArray).then(() => {
          callback()
        }).catch(err => {
          callback(err)
        })
      },
      acceptUsername (username) {
        this.model['username'] = username
      },
      //账号密码登录
      handleLogin () {
        this.validateFields(['username', 'password'], (err) => {
          if (!err) {
            let loginParams = {
              username: this.model.username,
              password: this.model.password,
              id: this.manager,
            }
            httpAction(this.url.accountDetect, loginParams, 'post').then((res) => {
              if (res.success) {
                this.$emit('ok');
                this.close();
              } else {
                this.$message.warning(res.message);
              }
            })
          }
        })
      },
      show (manager, title) {
        if (!this.disableSubmit) {
          this.manager = manager;
        }
        this.title = title;
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.handleLogin();
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>